/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "tag": {
      "delete": "Delete"
    }
  },
  "de-DE": {
    "tag": {
      "delete": "Löschen"
    }
  },
  "es-ES": {
    "tag": {
      "delete": "Eliminar"
    }
  },
  "fr-FR": {
    "tag": {
      "delete": "Supprimer"
    }
  },
  "id-ID": {
    "tag": {
      "delete": "Hapus"
    }
  },
  "it-IT": {
    "tag": {
      "delete": "Elimina"
    }
  },
  "jp-JP": {
    "tag": {
      "delete": "削除"
    }
  },
  "ko-KO": {
    "tag": {
      "delete": "삭제"
    }
  },
  "nl-NL": {
    "tag": {
      "delete": "Verwijderen"
    }
  },
  "pl-PL": {
    "tag": {
      "delete": "Usuń"
    }
  },
  "pt-PT": {
    "tag": {
      "delete": "Excluir"
    }
  },
  "ru-RU": {
    "tag": {
      "delete": "Удалить"
    }
  },
  "tr-TR": {
    "tag": {
      "delete": "Sil"
    }
  },
  "vi-VN": {
    "tag": {
      "delete": "Xóa"
    }
  },
  "zh-CN": {
    "tag": {
      "delete": "删除"
    }
  },
  "zh-TW": {
    "tag": {
      "delete": "刪除"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
